
import formAPIImaging from "./imaging";


var formattedOutput = null;

const formAPIModelImaging = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data?.map(item => formAPIImaging(item));


  return formattedOutput
};

export default formAPIModelImaging